<template>
  <div>
    <b-button
      variant="outline-primary"
      size="md"
      class="my-2 my-md-0"
      title="31 Items"
      :title="`${Array.isArray(items) ? items.length : '0'} ${itemsName} `"
      @click="handleToggleSideBar"
    >
      <b-icon icon="menu-button" variant="warning" aria-hidden="true" />
    </b-button>
    <b-sidebar
        :ref="refId"
      :visible="sidebarModel"
      sidebar-class="border-right border-danger"
      right
      shadow
      lazy
      :no-header="true"
    >
      <b-card
          v-for="(anItem, i) in items"
          @click="handleItemClick(anItem)"
          :key="`pl-${i}`"
          style="cursor: pointer; vert-align: middle"
      >
        <b-row>
          <!-- find all and organize-->
          <b-col aria-colspan="3">
            <b-img
                v-bind="mainProps"
                :src="`${assetsUrlHome}${anItem.imgURL}`"
                rounded
                alt="Rounded image"
            />
          </b-col>
          <b-col aria-colspan="9">
            <b-card-text>
              {{ anItem.title }}
              <smaller v-if="anItem.time">
                ({{ anItem.time }})
              </smaller>
            </b-card-text>
            <b-card-text>
              {{ anItem.artist }}
            </b-card-text>
            <b-card-text
                v-if="anItem.descsription"
            >
              {{ anItem.descsription }}
            </b-card-text>
          </b-col>
        </b-row>
      </b-card>
      <template #footer>
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <strong class="mr-auto">
          </strong>
          <b-button size="sm" @click="handleCloseSideBar">Close</b-button>
        </div>
      </template>
      <div></div>
    </b-sidebar>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "Resource_Items_SideBar",
  components: {},
  props: {
    refId: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      default: () => [],
      required: false
    },
    assetsUrlHome: {
      type: String,
      default: "",
      required: false
    },
    itemsName: {
      type: String,
      default: "items",
      required: false
    },
    updatedAt: {
      type: String,
      default: "",
      required: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    formatDate(date) {
      return date
          ? moment(date.toDate()).format("MMMM DD, YYYY h:MM a")
          : "N/A";
    }, /*@TODO- maybe be able to make a Sibebar Mixin*/
    handleToggleSideBar() {
      this.sidebarModel = !this.sidebarModel;
    },
    handleItemClick(item) {
      this.$emit("item-clicked", item);
      this.handleCloseSideBar();
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    }
  },
  data() {
    return {
      sidebarId: "item-sidebar",
      sidebarModel: false,
      itemsOrderedByDate:
          this.items && Array.isArray(this.items)
              ? this.items.sort(function(a, b) {
                return Date.parse(a._created_at) > Date.parse(b._created_at);
              })
              : [],
      /* SLIDE INFO*/
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
